module.exports = __webpack_public_path__ + "static/media/logo.123b02ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/main/logo.svg
// module id = 55
// module chunks = 0